module.exports = __webpack_public_path__ + "img/logo_ikea@3x.a3938843.png";